import { IAccountingBasisDTO } from '@modeso/types__aumico-lib-settings-be';
import { ProjectStatus } from '../enums/project-status.enum';
import { ReportStatus } from '../enums/report-status.enum';
import { WorkflowDataDto } from './workflow-data.dto.interface';

export class ProjectMetaInformationDto {
    projectName: string;
    projectId: string;
    companyId: string;
    companyName: string;
    label?: string;
    balanceSheetDate: string;
    projectStatus: ProjectStatus;
    reportStatus: ReportStatus;
    annualReportMetaData: string;
    assignee?: string | null;
    clerk?: string | null;
    workflowData?: WorkflowDataDto[] | null;
    lastTimeSynchronizedMM?: string;
    lastTimeSynchronizedCP?: string;
    selectedWorkflowId?: string;
    workflowLastChanged?: Date;
    isParentProject?: boolean;
    parentProjectId?: string;
    accountingBasis?: IAccountingBasisDTO;
    /**
     * When this closing last pulled its ERP successfully. Absent when it never has.
     *
     * Written by the sync, never by a user — the update payload has no counterpart. The two
     * `lastTimeSynchronized*` fields above are a different thing: they track the mandate-management
     * and closing-process synchronisations, not the ERP.
     *
     * Part of what this route answers; the closing header does NOT read it from here. That store is
     * filled by the projects overview, which the closing screen never loads, so a header reading it
     * there read nothing. It comes from the closing's own journals route instead.
     */
    lastErpSyncAt?: string;
    /**
     * When the ABCP closing was started — the same gate the closing's own navigation reads. Only the
     * list route sends it; absent when the closing was never started or the lookup failed.
     */
    closingStartedAt?: string;
}
